export const defaultGuides = {
  '/docs': [
    {
      name: 'Overview.md',
      content: '## some info about the local viewer',
    },
  ],
  items: [
    {
      title: 'Local Viewer',
      articles: [
        {
          label: 'Overview',
          content: 'some info about the local viewer',
          isMdFile: true,
        },
      ],
    },
  ],
};

export const STORE_MODES = {
  LOCAL_VIEWER: 'local-viewer',
  BRANCH: 'branch',
  REGULAR: 'regular',
};
